import { FormHelperText, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Alert } from '@mui/material'
import DialogConfirmCancel from './DialogConfirm'
import InputField from '../FormControl/input/InputField'
import SelectField from '../FormControl/input/SelectField'
import ButtonStartIcon from '../button/ButtonStartIcon'
import isEmpty from 'lodash/isEmpty'
import { validate } from '../../utils'

const DialogAttachMedia = ({ onClose, open, formData, onSave, type }) => {
  const types = ['add', 'delete'];
  const [form, setForm] = useState(formData);
  const [errors, setError] = useState(null);

  const onChange = (key, value) => {
    if (key === 'type') {
      setForm({ type: value, description: '', link: '', file: null })
      setError({ ...errors, [key]: null })
    } else if (key === 'file') {
      setError({ ...errors, [key]: null })
      setForm({ 
        ...form, 
        [key]: value, 
        description: value.name,
        name: value.name,
        size: value.size,
        lastModified: value.lastModified,
        extension: value.name.split('.').pop(),
        mimetype: value.type, 
      })
    } else {
      setForm({ ...form, [key]: value })
      setError({ ...errors, [key]: null })
    }
  }

  const onConfirm = async (e) => {
    e.preventDefault();
    if (!types.includes(type)) {
      setError({ message: 'Invalid type' })
      return
    }
    if (type === 'delete') {
      await onSave(form);
      onClose();
      return
    } else {
      const fieldRules = {
        type: 'required'
      }
      if (form.type === 'link') {
        fieldRules.link = 'required|url'
      }

      if (form.type === 'file') {
        fieldRules.file = 'required'
      }

      const errors = validate(fieldRules, form)
      if (!isEmpty(errors)) {
        setError(errors)
      } else {
        await onSave(form);
        onClose();
      }
    }
  }

  return (
    <DialogConfirmCancel
      id='attach-media'
      open={open}
      onCancel={onClose}
      disabledConfirm={!form.type}
      onConfirm={onConfirm}
      title={type === 'delete' ? 'Delete media' : 'Attach media'}
      maxWidth='xs'
    >
      { type === 'delete' ?
        <Typography>
          Are you sure you want to delete this media {form.type}? 
        </Typography>
        :
        <div className='grid grid-cols-4 items-center gap-4'>
          <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
            Type
          </Typography>
          <div className='col-span-3'>
            <SelectField
              id='type'
              name='type'
              value={form.type}
              error={errors?.type}
              helperText={errors?.type}
              onChange={(e) => onChange("type", e.target.value)}
              fullWidth
              placeholder='Choose an option'
              options={[
                { value: 'file', label: 'File' },
                { value: 'link', label: 'Link' },
              ]}
            />
          </div>
          { form.type === 'link' &&
            <>
              <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
                URL
              </Typography>
              <div className='col-span-3'>
                <InputField
                  id='link'
                  name='link'
                  value={form.link}
                  error={errors?.link}
                  helperText={errors?.link}
                  onChange={(e) => onChange("link", e.target.value)}
                  fullWidth
                />
              </div>
            </>
          }
          { form.type === 'file' &&
            <>
              <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
                Upload file
              </Typography>
              <div className='col-span-3'>
                <label htmlFor="file-upload">
                  <ButtonStartIcon
                    color='primary'
                    variant='outlined'
                    disabled={false}
                    startIcon={["fal","upload"]}
                    className={form.file ? 'w-full' : 'w-full'}
                    component='span'
                  >
                    <div className='font-bold text-nowrap text-xs text-ellipsis'>
                      {form.file ? form.file.name : 'Choose file'}
                    </div>
                  </ButtonStartIcon>
                </label>
                <input
                  id="file-upload" 
                  type="file"
                  name="file"
                  style={{ display: 'none' }}
                  onChange={(e) => onChange('file', e.target.files[0])}
                />
                { errors?.file &&
                  <FormHelperText error>{errors?.file}</FormHelperText>
                }
              </div>
            </>
          }
          { form.type &&
            <>
              <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
                Description
              </Typography>
              <div className='col-span-3'>
                <InputField
                  id='description'
                  name='description'
                  value={form.description}
                  error={errors?.description}
                  helperText={errors?.description}
                  onChange={(e) => onChange("description", e.target.value)}
                  fullWidth
                  multiline={true}
                />
              </div>
            </>
          }
        </div>
      }
      
      { errors && errors.message &&
        <Alert severity='error'>{errors.message}</Alert>
      }
    </DialogConfirmCancel>
  )
}

export default DialogAttachMedia